import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const kitchenTeamLeadDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.kitchenTeam,
  componentType: LAYOUT_COMPONENT_TYPE.kitchenTeamBlock,
  registryBlockKey: REGISTRY_BLOCK.presentation.kitchenTeamLead,
  displayOrder: 3,
  content: {
    sectionTitle: loc3('Küche & Team', 'Kitchen & team', 'Bếp & đội ngũ'),
    supporting: loc3(
      'Wenige Hände am Pass. Jede Rolle klar, kein Auftritt.',
      'Few hands at the pass. Each role clear, no performance.',
      'Ít tay ở pass. Mỗi vai rõ, không trình diễn.',
    ),
    memberName0: loc3('Clara Voss', 'Clara Voss', 'Clara Voss'),
    memberRole0: loc3('Küchenchefin', 'Chef de cuisine', 'Bếp trưởng'),
    memberBio0: loc3(
      'Menü und Pass — die Linie des Abends.',
      'Menu and pass — the line of the evening.',
      'Thực đơn và pass — đường của buổi tối.',
    ),
    memberName1: loc3('Jonas Weber', 'Jonas Weber', 'Jonas Weber'),
    memberRole1: loc3('Sous-chef', 'Sous-chef', 'Phụ bếp'),
    memberBio1: loc3(
      'Fonds, Garung, Mise en place.',
      'Stocks, cooking, mise en place.',
      'Nước dùng, chín, mise en place.',
    ),
    memberName2: loc3('Léa Moreau', 'Léa Moreau', 'Léa Moreau'),
    memberRole2: loc3('Pâtisserie', 'Pastry', 'Bánh ngọt'),
    memberBio2: loc3(
      'Der letzte Gang — ruhig und präzise.',
      'The last course — quiet and precise.',
      'Món cuối — yên và chính xác.',
    ),
  },
  media: {
    leadImage: '/platform/defaults/facilities/restaurant/michelin-dark-04.jpg',
  },
};
